module.exports = __webpack_public_path__ + "static/LogoBlueHR-c1522a78f20b091a7597c76bdd67a11a.svg";